import React from 'react';
import './App.css';
import Navigation from "./components/Navigation";
import ProductDetail from "./components/ProductDetails/ProductDetail";
import ProcessSteps from "./components/Process/Processsteps";
import MotionSlider3D from "./components/MotionSlider3D";
import AboutUs from "./components/AboutUs";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

function App() {
  return (
      <>
        <Navigation />
          <ProductDetail />
          <AboutUs/>
          <MotionSlider3D/>
          <ProcessSteps />
          <ContactForm/>
          <Footer />
      </>
  );
}

export default App;
